import { i18n } from '@/services/i18n';
import ROUTE_NAMES from '@/router/dashboard/ROUTE_NAMES';
import DashboardView from '@/views/dashboard/DashboardView.vue';

export default [
  {
    path: '/dashboard',
    name: ROUTE_NAMES.DASHBOARD,
    component: DashboardView,
    meta: {
      authOnly: true,
      title: i18n.t('GENERAL.DETAILED_VIEW'),
    },
  },
  { path: '/dashboard', component: DashboardView },
];
